import React from 'react';
import PropTypes from 'prop-types';
import Button from 'core/ui/Button';

import { StyledButton } from './writeReviewStyles';


class WriteReviewButton extends React.Component {
	state = {
		open: false,
	}

	handleClick = (e) => {
		e.preventDefault();
		this.props.onClick(e);
	}

	render() {
		const { children, styledButton, slug, ...btnProps } = this.props;
		const StyledBtn = styledButton;
		return (
			<StyledBtn {...btnProps}
				onClick={this.handleClick}
				href={`/subscription-box/${slug}/reviews/?write_review=true`}>
				{children}
			</StyledBtn>
		);
	}
}

WriteReviewButton.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node
	]).isRequired,
	slug: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	styledButton: PropTypes.any,
	size: Button.propTypes.size,
	themeType: Button.propTypes.themeType,
};

WriteReviewButton.defaultProps = {
	onClick: () => null,
	styledButton: StyledButton,
	size: 'sm',
	themeType: Button.defaultProps.themeType,
};

export default WriteReviewButton;
